import React, { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../context/UserContext";

import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
} from "@material-ui/core";

import apolo from "../../assets/apolo.svg";

const useStyles = makeStyles({
  headerItem: {
    margin: "0 10px",
    display: "flex",
    alignItems: "center",
    height: "64px",
  },

  headerButton: {
    textDecoration: "none",
    color: "#fff",
    background: "transparent",
    border: "none",
    padding: "10px 15px",
    margin: 0,
    cursor: "pointer",
    fontSize: "16px",
    fontFamily: "inherit",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",

    "&:focus": {
      outline: "none",
    },
  },

  profileLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    color: "#fff",
    height: "100%",
  },

  menuItemStyle: {
    color: "#FF4136",
  },

  appBar: {
    zIndex: 999,
    position: "absolute",
    top: 0,
    height: "4rem",
    backgroundColor: "#00293B",
  },

  userMenu: {
    width: "160px",
    height: "50px",
    backgroundColor: "white",
    borderRadius: "12px",
    cursor: "pointer",
  },

  userMenuContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    height: "100%",
    width: "100%",
  },
});

const Header = ({ user }) => {
  const { setUserData, userData } = useContext(UserContext);

  // Pega o ID do colaborador logado
  const userId = parseInt(
    userData?.user?.id_colaborador ||
      user?.id_colaborador ||
      null,
    10
  );

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [gestaoAnchorEl, setGestaoAnchorEl] = React.useState(null);
  const [ataAnchorEl, setAtaAnchorEl] = React.useState(null);
  const [colaboradorAnchorEl, setColaboradorAnchorEl] = React.useState(null);

  const handleCloseColaborador = () => {
    setColaboradorAnchorEl(null);
  };

  const handleCloseAta = () => {
    setAtaAnchorEl(null);
  };

  const handleCloseGestao = () => {
    setGestaoAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setUserData({
      token: undefined,
      user: undefined,
    });

    localStorage.setItem("auth-token", "");

    window.location.href = process.env.REACT_APP_APPLICATION_URL;
  };

  console.log(
    "REACT_APP_FEATURE_FLAG:",
    process.env.REACT_APP_FEATURE_FLAG,
    typeof process.env.REACT_APP_APPLICATION_URL
  );

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          height: "100%",
        }}
      >
        {/* Menu esquerdo */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* Perfil */}
          <div className={classes.headerItem}>
            <Link to="/perfil" className={classes.profileLink}>
              <img
                src={apolo}
                alt="Meu perfil"
                height="78px"
                width="78px"
                style={{
                  borderRadius: "24px",
                  display: "block",
                }}
              />
            </Link>
          </div>

          {/* Gestão */}
          {user?.isProjectManager && (
            <div className={classes.headerItem}>
              <button
                type="button"
                className={classes.headerButton}
                onClick={(e) => setGestaoAnchorEl(e.currentTarget)}
              >
                Gestão
              </button>

              <Menu
                id="menu-gestao"
                anchorEl={gestaoAnchorEl}
                keepMounted
                open={Boolean(gestaoAnchorEl)}
                onClose={handleCloseGestao}
                style={{
                  marginTop: "50px",
                }}
              >
                <MenuItem onClick={handleCloseGestao} style={{ padding: 0 }}>
                  <Link
                    to="/planejamento-projeto"
                    style={{
                      textDecoration: "none",
                      color: "#111",
                      display: "block",
                      width: "100%",
                      padding: "6px 16px",
                    }}
                  >
                    Planejamento
                  </Link>
                </MenuItem>

                <MenuItem onClick={handleCloseGestao} style={{ padding: 0 }}>
                  <Link
                    to="/relatorio-projeto"
                    style={{
                      textDecoration: "none",
                      color: "#111",
                      display: "block",
                      width: "100%",
                      padding: "6px 16px",
                    }}
                  >
                    Relatório
                  </Link>
                </MenuItem>

                <MenuItem onClick={handleCloseGestao} style={{ padding: 0 }}>
                  <Link
                    to="/orcamento"
                    style={{
                      textDecoration: "none",
                      color: "#111",
                      display: "block",
                      width: "100%",
                      padding: "6px 16px",
                    }}
                  >
                    Orçamento
                  </Link>
                </MenuItem>

                <MenuItem onClick={handleCloseGestao} style={{ padding: 0 }}>
                  <Link
                    to="/horas-por-executante"
                    style={{
                      textDecoration: "none",
                      color: "#111",
                      display: "block",
                      width: "100%",
                      padding: "6px 16px",
                    }}
                  >
                    Horas por executante
                  </Link>
                </MenuItem>

                <MenuItem onClick={handleCloseGestao} style={{ padding: 0 }}>
                  <Link
                    to="/alocamento-diario"
                    style={{
                      textDecoration: "none",
                      color: "#111",
                      display: "block",
                      width: "100%",
                      padding: "6px 16px",
                    }}
                  >
                    Alocação Diária
                  </Link>
                </MenuItem>
              </Menu>
            </div>
          )}

          {/* Atas */}
          <div className={classes.headerItem}>
            <button
              type="button"
              className={classes.headerButton}
              onClick={(e) => setAtaAnchorEl(e.currentTarget)}
            >
              Atas
            </button>

            <Menu
              id="menu-atas"
              anchorEl={ataAnchorEl}
              keepMounted
              open={Boolean(ataAnchorEl)}
              onClose={handleCloseAta}
              style={{
                marginTop: "50px",
              }}
            >
              <MenuItem onClick={handleCloseAta}>
                <Link
                  to="/nova-ata"
                  style={{
                    textDecoration: "none",
                    color: "#111",
                  }}
                >
                  Nova Ata
                </Link>
              </MenuItem>

              <MenuItem onClick={handleCloseAta}>
                <Link
                  to="/documentos-ata"
                  style={{
                    textDecoration: "none",
                    color: "#111",
                  }}
                >
                  Documentos
                </Link>
              </MenuItem>
            </Menu>
          </div>

          {/* Colaborador */}
          <div className={classes.headerItem}>
            <button
              type="button"
              className={classes.headerButton}
              onClick={(e) => setColaboradorAnchorEl(e.currentTarget)}
            >
              Colaborador
            </button>

            <Menu
              id="menu-colaborador"
              anchorEl={colaboradorAnchorEl}
              keepMounted
              open={Boolean(colaboradorAnchorEl)}
              onClose={handleCloseColaborador}
              style={{
                marginTop: "50px",
              }}
            >
              <MenuItem onClick={handleCloseColaborador}>
                <Link
                  to="/produtividade"
                  style={{
                    textDecoration: "none",
                    color: "#111",
                  }}
                >
                  Produtividade
                </Link>
              </MenuItem>
            </Menu>
          </div>

          {/* Configurações */}
          <div className={classes.headerItem}>
            <Link
              to="/projetos"
              className={classes.headerButton}
            >
              Configurações
            </Link>
          </div>
        </div>

        {/* Menu do usuário */}
        <div className={classes.userMenu}>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            style={{
              marginTop: "50px",
            }}
          >
            <MenuItem onClick={handleClose}>
              <Link
                to={`/editar-usuario/${userId}`}
                style={{
                  textDecoration: "none",
                  color: "#111",
                }}
              >
                Meu Perfil
              </Link>
            </MenuItem>

            <MenuItem
              onClick={handleLogout}
              className={classes.menuItemStyle}
            >
              Sair
            </MenuItem>
          </Menu>

          <div
            className={classes.userMenuContent}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            {/* Ícone de usuário */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 42 42"
              fill="none"
            >
              <path
                d="M21 36.12C15.75 36.12 11.109 33.432 8.4 29.4C8.463 25.2 16.8 22.89 21 22.89C25.2 22.89 33.537 25.2 33.6 29.4C30.891 33.432 26.25 36.12 21 36.12ZM21 6.3C22.6709 6.3 24.2733 6.96375 25.4548 8.14523C26.6363 9.32671 27.3 10.9291 27.3 12.6C27.3 14.2709 26.6363 15.8733 25.4548 17.0548C24.2733 18.2363 22.6709 18.9 21 18.9C19.3291 18.9 17.7267 18.2363 16.5452 17.0548C15.3637 15.8733 14.7 14.2709 14.7 12.6C14.7 10.9291 15.3637 9.32671 16.5452 8.14523C17.7267 6.96375 19.3291 6.3 21 6.3ZM21 0C18.2422 0 15.5115 0.543181 12.9636 1.59853C10.4158 2.65388 8.10079 4.20073 6.15076 6.15076C2.21249 10.089 0 15.4305 0 21C0 26.5695 2.21249 31.911 6.15076 35.8492C8.10079 37.7993 10.4158 39.3461 12.9636 40.4015C15.5118 41.4568 18.2422 42 21 42C26.5695 42 31.911 39.7875 35.8492 35.8492C39.7875 31.911 42 26.5695 42 21C42 9.387 32.55 0 21 0Z"
                fill="#006998"
              />
            </svg>

            {/* Nome */}
            <strong
              style={{
                color: "#000",
                fontSize: "10px",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "80px",
              }}
            >
              {user?.nome}
            </strong>

            {/* Seta */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="6"
              viewBox="0 0 12 6"
              fill="none"
            >
              <path
                d="M0 0L6 6L12 0H0Z"
                fill="#006998"
              />
            </svg>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
